import { render, staticRenderFns } from "./PointsModal.vue?vue&type=template&id=413a6492&scoped=true&lang=pug&"
import script from "./PointsModal.vue?vue&type=script&lang=js&"
export * from "./PointsModal.vue?vue&type=script&lang=js&"
import style0 from "./PointsModal.vue?vue&type=style&index=0&id=413a6492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413a6492",
  null
  
)

export default component.exports